import { createSlice } from '@reduxjs/toolkit';

const innerRangeSlice = createSlice({
	name: 'innerRange',
	initialState: { loading: false, error: null },
	reducers: {
		triggerSync: (state) => {
			state.loading = true;
		},
		triggerSyncSuccess: (state) => {
			state.loading = false;
		},
		triggerSyncError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	}
});

export const innerRangeActions = innerRangeSlice.actions;
export default innerRangeSlice.reducer;
